import Template from "../app/Template";
import Button from "../layout/Button";
import Card from "../layout/Card";
import ContactUsBanner from "../contact/ContactUsBanner";

const topics = [
  "ADHD & perimenopause",
  "Parenting neurodivergent children",
  "Neurodiversity at work",
  "Self-identification & diagnosis",
  "Advocating for yourself & others",
  "From strategy to startup"
]


export default function Speaking() {
  return (
    <Template>

      {/* Hero */}
      <div className="hidden lg:block">
        <div
          className="h-[800px] lg:h-[1100px] flex items-center px-8 lg:px-12 relative"
          style={{
            // Image path is relative to the 'public' folder
            backgroundImage: 'url("/img/graphics/hero/speaker-hero.JPG")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            width: '100%',
            position: 'relative', // Ensures child elements with absolute positioning are positioned relative to this container
          }}
        >
          <Card className="ml-auto w-4/5 lg:w-4/5 xl:w-3/5 grid grid-cols-1 gap-y-4">

            {/* Header */}
            <div>
              <h1 className="text-dark-grey text-lg md:text-lg lg:text-2xl font-bold">Public Speaking</h1>
            </div>

            {/* Text */}
            <div className="grid grid-cols-1 gap-y-4 text-dark-grey font-medium">
              <p className="font-bold text-sm lg:text-base">From boardrooms to building a movement - insight, advocacy, and practical action for a more neuro-inclusive world.</p>
              <p className="text-sm lg:text-base">Alexandra brings a rare combination of lived experience, executive leadership, and unapologetic honesty to the conversation around neurodiversity.</p>
              <p className="text-sm lg:text-base">With over 20 years in large global organisations - including as Head of Transformation at Barclays - she knows firsthand how the workplace can both stifle and supercharge neurodivergent talent. Her sessions bridge the gap between awareness and action, energising audiences with insights that are grounded, authentic, and ready to apply.</p>
              <p className="text-sm lg:text-base">Now the founder of RaiseDiversity, Alexandra speaks to the human realities behind the headlines: navigating diagnosis, parenting neurodivergent children, hormonal shifts and ADHD, and building a business designed for change.</p>
              <p className="text-sm lg:text-base">Alexandra brings a rare combination of lived experience, executive leadership, and unapologetic honesty to the conversation around neurodiversity.</p>
              <p className="font-bold">Why book Alexandra?</p>
              <p className="text-sm lg:text-base">Alexandra’s talks are known for their clarity, empathy, and impact. She blends strategic insight with personal storytelling to challenge assumptions and champion change. Her sessions connect people across roles - from HR and leadership to teams, employee networks, parents and educators - creating a shared language and direction.</p>
              <p className="font-bold">Speaking topics include:</p>
            </div>
            <div className="flex flex-wrap gap-2 justify-start items-center">
              {topics.map((topic, index) => {
                return (
                  <Button
                    key={`topic-${index}`}
                    onClick={() => console.log(topic)}
                    width="fit"
                    bgColour="dark-blue"
                    borderColour="dark-blue"
                    textColour="white"
                  >
                    {topic}
                  </Button>
                );
              })}
            </div>
          </Card>

          {/* Bubbles */}
          <img
            src="/img/graphics/bubbles/bubble-left-green.svg"
            alt="Bubble"
            className="absolute w-44 object-cover top-36 right-0 z-0"
          />
          <img
            src="/img/graphics/bubbles/bubble-right-blue.svg"
            alt="Bubble"
            className="absolute w-52 lg:w-52 object-cover bottom-10 lg:bottom-16 right-[33rem] z-0"
          />
        </div>
      </div>

      <div className="block lg:hidden">
        <div
          className="h-fit bg-off-white relative py-12"
        >
          <Card className="w-full grid grid-cols-1 gap-y-4" paddingX="px-8" paddingY="py-8">

            {/* Header */}
            <div>
              <h1 className="text-dark-grey text-lg md:text-3xl font-bold">Public Speaking</h1>
            </div>

            {/* Text */}
            <div className="grid grid-cols-1 gap-y-4 text-dark-grey text-sm lg:text-base lg:text-xl font-medium">
              <p className="font-bold">From boardrooms to building a movement - insight, advocacy, and practical action for a more neuro-inclusive world.</p>
              <p className="text-sm lg:text-base">Alexandra brings a rare combination of lived experience, executive leadership, and unapologetic honesty to the conversation around neurodiversity.</p>
              <p className="text-sm lg:text-base">With over 20 years in large global organisations - including as Head of Transformation at Barclays - she knows firsthand how the workplace can both stifle and supercharge neurodivergent talent. Her sessions bridge the gap between awareness and action, energising audiences with insights that are grounded, authentic, and ready to apply.</p>
              <p className="text-sm lg:text-base">Now the founder of RaiseDiversity, Alexandra speaks to the human realities behind the headlines: navigating diagnosis, parenting neurodivergent children, hormonal shifts and ADHD, and building a business designed for change.</p>
              <p className="text-sm lg:text-base">Alexandra brings a rare combination of lived experience, executive leadership, and unapologetic honesty to the conversation around neurodiversity.</p>
              <p className="font-bold">Why book Alexandra?</p>
              <p className="text-sm lg:text-base">Alexandra’s talks are known for their clarity, empathy, and impact. She blends strategic insight with personal storytelling to challenge assumptions and champion change. Her sessions connect people across roles - from HR and leadership to teams, employee networks, parents and educators - creating a shared language and direction.</p>
              <p className="font-bold">Speaking topics include:</p>
            </div>
            <div className="flex flex-wrap gap-2 justify-start items-center">
              {topics.map((topic, index) => {
                return (
                  <Button
                    key={`topic-${index}`}
                    onClick={() => console.log(topic)}
                    width="fit"
                    bgColour="dark-blue"
                    borderColour="dark-blue"
                    textColour="white"
                  >
                    {topic}
                  </Button>
                );
              })}
            </div>
          </Card>

        </div>
      </div>

      {/* Contact us */}
      <ContactUsBanner />

    </Template>
  );
}
